import {get, post} from './api';

const getUser = get('user/get'); //获取其他用户的信息
const me = get('user/me'); //获取自己的信息
const createUser = post('user/create');
const login = post((location.origin.indexOf('localhost') >= 0 || location.port == "8877" || location.origin.indexOf('dev.zhiaotech.com') >= 0 || location.origin.indexOf("192.168.") >= 0 || location.origin.indexOf("127.0.0.1") >= 0) ? 'user/login_dev' : 'user/login');
/*
更新用户信息示例：
{
    "name": "郑祺",
    "avatar: "1.png"
}
 */
const update = post('user/update');

/*
重置密码示例：
{
    "phone": "18611464994",
    "code": "1234",
    "password": "xxxx",
    "password_confirmation": "xxxx"
}
 */
const resetPassword = post('user/reset-password'); //重置密码

/*
更新密码示例：
{
    "old_password": "xxxx",
    "password": "xxxx",
    "password_confirmation": "xxxx"
}
 */
const updatePassword = post('user/update-password');

/*
更新手机号示例：
{
    "password": "xxxx",
    "phone": "18611464991",
    "code": "1234"
}
 */
const updatePhone = post('user/update-phone'); //更新手机号

const joinedClazzes = get('user/joined-clazzes'); //加入的班级

const cnPerformance = get('cn/performance')  //获取渠道号、个人推广数量、渠道号推广数量

//分享作品

const shareProject = get('project/user-shared')

// 重置密码
const resetPasswd = post('user/teacher-reset-student-password')

//获取渠道优惠码
const getInquiryCode = get('channel/mine')

export {
    getUser,
    me,
    createUser,
    login,
    update,
    resetPassword,
    updatePassword,
    updatePhone,
    joinedClazzes,
    cnPerformance,
    shareProject,
    resetPasswd,
    getInquiryCode
};
